import AxiosClient from './api'
import END_POINT from './constants'
import {
  createPortfolioLocal,
  getPortfoliosByUserIdLocal,
  getPortfolioByIdLocal,
  deletePortfolioLocal,
  updateTimeIPOLocal,
  getAssetGoalsLocal,
  getGrowthSchedulesLocal,
  updateAssetGoalsLocal,
  updateGrowthSchedulesLocal,
  updatePortfolioNameLocal,
  getAllRolesLocal,
  getAllMembersLocal,
  updateCurrencyLocal
} from 'Utils/portfolioStorage'

const useLocalStorage = import.meta.env.VITE_USE_LOCAL_STORAGE === 'true'
const hasApiUrl = !!import.meta.env.VITE_BASE_API_URL

export function createPortFolio(payload) {
  if (useLocalStorage || !hasApiUrl) {
    return Promise.resolve(createPortfolioLocal(payload))
  }
  const apiPayload = {
    ...payload,
    client_name: payload.clientName ?? payload.client_name
  }
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.PORTFOLIO.PORTFOLIO}`, apiPayload)
      .then((res) => resolve(res.data))
      .catch((err) => {
        const message = err?.message
          || err?.error?.message
          || (typeof err === 'string' ? err : 'API_ERROR')
        reject(message)
      })
  })
}

export function getPortFolioByUserId() {
  if (useLocalStorage) {
    return Promise.resolve(getPortfoliosByUserIdLocal())
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.GET_PORTFOLIO_BY_USERID}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function getPortFolioWithId({ id }) {
  if (useLocalStorage) {
    return Promise.resolve(getPortfolioByIdLocal({ id }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function deletePortFolioWithId({ id }) {
  if (useLocalStorage) {
    return Promise.resolve(deletePortfolioLocal({ id }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function updateTimeIPOPortfolio({ id, time }) {
  if (useLocalStorage) {
    return Promise.resolve(updateTimeIPOLocal({ id, time }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/timeipo/${time}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function getAssetGoalsWithRequest({ id }) {
  if (useLocalStorage) {
    return Promise.resolve(getAssetGoalsLocal({ id }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/asset-goals`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function getGrowthSchedulesWithRequest({ id }) {
  if (useLocalStorage) {
    return Promise.resolve(getGrowthSchedulesLocal({ id }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/growth-schedules`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function editAnnualAssetGoalsWithRequest({ id, ...payload }) {
  if (useLocalStorage) {
    return Promise.resolve(updateAssetGoalsLocal({ id, ...payload }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/asset-goals`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function editGrowthSchedulesWithRequest({ id, ...payload }) {
  if (useLocalStorage) {
    return Promise.resolve(updateGrowthSchedulesLocal({ id, ...payload }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/growth-schedules`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function getAllRolePermissionRequest({ id }) {
  if (useLocalStorage) {
    return Promise.resolve(getAllRolesLocal({ id }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.MEMBER_ROLES}/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function getAllMemberInPortFolioRequest({ id }) {
  if (useLocalStorage) {
    return Promise.resolve(getAllMembersLocal({ id }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.ALL_MEMBER_PORTFOLIO}/${id}/members?sortBy=role_id&sortType=ASC`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function inviteMemberPortFolio({ id, ...payload }) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: {} })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.PORTFOLIO.PORTFOLIO_MEMBER_INVITE}/${id}/invite-member`, { ...payload.values })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function acceptInvitationMemberOfPortfolio(payload) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: {} })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.PORTFOLIO.ACCEPT_INVITE_MEMBER}`, { ...payload })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function verifyInvitationMemberOfPortfolio({ code }) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: {} })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PORTFOLIO.VERIFY_INVITE_MEMBER}/${code}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function deletePortfolioMemberRequest({ id, userId, ...payload }) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: {} })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.PORTFOLIO.DELETE_PORTFOLIO_MEMBER}/${id}/members/${userId}`, { ...payload })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updatePortfolioName({ id, name }) {
  if (useLocalStorage) {
    return Promise.resolve(updatePortfolioNameLocal({ id, name }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.PORTFOLIO}/${id}/name/${name.name}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function updateCurrency({ id, currency }) {
  if (useLocalStorage) {
    return Promise.resolve(updateCurrencyLocal({ id, currency }))
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.PORTFOLIO.UPDATE_CURRENCY}/${id}/currency/${currency}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
